import React from "react";

import AddressAutocomplete from "../../../../../components/admin/AddressAutocomplete";
import ListingFieldGroup from "../components/ListingFieldGroup";
import {
  choiceRow,
  fieldHint,
  fieldInput,
  fieldLabel,
  grid2,
} from "../listingEditorStyles";

/**
 * "Adresse & Lage": the address, what the public site shows instead of it,
 * and the coordinates.
 *
 * This is the ONLY place the address can be edited — Basisinformationen
 * deliberately does not repeat it.
 *
 * `onAddressSelect` is passed straight through, by reference. It is the
 * `useCallback(..., [])` from the form hook, and AddressAutocomplete lists it
 * in its effect dependencies — an unstable identity would construct a fresh
 * Google Places Autocomplete on every render (discovery risk R8). Do not wrap
 * it in an inline arrow. The inline arrow on `onChange` below is fine: that
 * prop is not in those dependencies.
 *
 * Coordinates stay editable text inputs. They also stay impossible to clear
 * through this form — the payload builder omits the keys entirely when the
 * fields are empty, so the server keeps whatever it had (discovery risk R9).
 * L5 characterizes that; it does not fix it.
 */
export default function ListingLocationSection({
  form,
  setForm,
  onChange,
  onAddressSelect,
}) {
  return (
    <>
      <ListingFieldGroup
        title="Adresse"
        description="Adresse des Listings und ihre Sichtbarkeit auf der Website."
      >
        <div>
          <label className={fieldLabel}>Adresse</label>
          <AddressAutocomplete
            value={form.address}
            onChange={(e) => setForm((prev) => ({ ...prev, address: e.target.value }))}
            onAddressSelect={onAddressSelect}
            className={fieldInput}
            placeholder="z.B. Baselstrasse 35, 4500 Solothurn"
          />
        </div>

        <div>
          <label className={choiceRow}>
            <input
              type="checkbox"
              name="show_address"
              checked={form.show_address}
              onChange={onChange}
            />
            Echte Adresse auf der Website anzeigen
          </label>
          <p className={fieldHint}>
            Steuert nur, ob die gespeicherte Adresse öffentlich auf der Website
            angezeigt wird. Ausgeschaltet bleibt sie gespeichert und hier sichtbar.
          </p>
        </div>
      </ListingFieldGroup>

      <ListingFieldGroup
        title="Lagebeschreibung"
        description="Kurzer öffentlich sichtbarer Hinweis zur Lage."
      >
        <div>
          <label htmlFor="listing-location-description" className={fieldLabel}>
            Standort-Beschreibung (für Website)
          </label>
          <input
            id="listing-location-description"
            type="text"
            name="location_description"
            value={form.location_description}
            onChange={onChange}
            placeholder="z.B. Nähe Hauptbahnhof, Solothurn Weststadt"
            className={fieldInput}
          />
          <p className={fieldHint}>
            Wird auf der Marketing-Site angezeigt statt/zusätzlich zur Adresse.
          </p>
        </div>
      </ListingFieldGroup>

      <ListingFieldGroup
        title="Standortkoordinaten"
        description="Latitude und Longitude werden aus einem ausgewählten Adressvorschlag übernommen und können manuell angepasst werden."
      >
        <div className={grid2}>
          <div>
            <label htmlFor="listing-latitude" className={fieldLabel}>
              Latitude
            </label>
            <input
              id="listing-latitude"
              type="text"
              name="latitude"
              value={form.latitude}
              onChange={onChange}
              placeholder="z.B. 47.3769"
              className={fieldInput}
            />
          </div>
          <div>
            <label htmlFor="listing-longitude" className={fieldLabel}>
              Longitude
            </label>
            <input
              id="listing-longitude"
              type="text"
              name="longitude"
              value={form.longitude}
              onChange={onChange}
              placeholder="z.B. 8.5417"
              className={fieldInput}
            />
          </div>
        </div>
      </ListingFieldGroup>
    </>
  );
}
